import React from "react";
import GridOnIcon from "@mui/icons-material/GridOn";
import StickyNote2OutlinedIcon from "@mui/icons-material/StickyNote2Outlined";
import { OrangeTextButton } from "../../common/OrangeTextButton";

export const AlertClipToolbar = ({
  showIgnoreZones,
  showLineCrossings,
  onToggleIgnoreZones,
  onToggleLineCrossings,
  canShowLineCrossings,
  canShowSiteVideoWall,
  onSiteVideoWall,
  canViewProtocolNotes = false,
  onViewProtocolNotes,
}: {
  showIgnoreZones: boolean;
  showLineCrossings: boolean;
  onToggleIgnoreZones: () => void;
  onToggleLineCrossings: () => void;
  canShowLineCrossings: boolean;
  canShowSiteVideoWall: boolean;
  onSiteVideoWall: () => void;
  // ENG-2421: shown when the alert's site or camera has notes.
  canViewProtocolNotes?: boolean;
  onViewProtocolNotes?: () => void;
}) => {
  return (
    // Two columns: show-chips on the left, protocol notes / wall on the right.
    // min-h keeps the row the same height between alerts whichever controls
    // are showing.
    <div className="mt-1 grid min-h-[30px] grid-cols-[minmax(0,1fr)_auto] items-center gap-2">
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-mulish text-[11px] font-bold text-actuate-blue">
          Show:
        </span>
        <button
          type="button"
          onClick={onToggleIgnoreZones}
          className={`rounded-full border px-2 py-0.5 font-mulish text-[11px] font-bold ${
            showIgnoreZones
              ? "border-actuate-orange bg-actuate-orange text-white"
              : "border-actuate-blue/30 bg-white text-actuate-blue"
          }`}
        >
          Ignore zones
        </button>
        {canShowLineCrossings && (
          <button
            type="button"
            onClick={onToggleLineCrossings}
            className={`rounded-full border px-2 py-0.5 font-mulish text-[11px] font-bold ${
              showLineCrossings
                ? "border-actuate-orange bg-actuate-orange text-white"
                : "border-actuate-blue/30 bg-white text-actuate-blue"
            }`}
          >
            Line crossings
          </button>
        )}
      </div>
      <div className="flex items-center justify-end gap-2">
        {canViewProtocolNotes && onViewProtocolNotes && (
          <OrangeTextButton
            text={
              <span className="inline-flex items-center gap-1 font-mulish text-[11px] font-bold">
                View Protocol / Notes
                <StickyNote2OutlinedIcon fontSize="small" />
              </span>
            }
            onClick={onViewProtocolNotes}
            disabled={false}
            sx={{ minWidth: "auto", padding: "2px 4px" }}
          />
        )}
        {canShowSiteVideoWall && (
          <OrangeTextButton
            text={
              <span className="inline-flex items-center gap-1 font-mulish text-[11px] font-bold">
                Site Video Wall
                <GridOnIcon fontSize="small" />
              </span>
            }
            onClick={onSiteVideoWall}
            disabled={false}
            sx={{ minWidth: "auto", padding: "2px 4px" }}
          />
        )}
      </div>
    </div>
  );
};
